module.exports = __webpack_public_path__ + "static/media/voodoo-magic.f6f7ca8e.gif";